module.exports = __webpack_public_path__ + "static/feazy_net_story-8f862e13aaf8b0fee0ec935a94d6eb5e.png";